export default __webpack_public_path__ + "static/media/cancel-icon.76dd3d18.svg";